import React from "react";

const STYLES = {
  validated: ["Validé", "bg-green-100 text-green-800 border-green-200"],
  unqualified: ["Pas qualifié", "bg-red-100 text-red-700 border-red-200"],
  pending: ["En attente", "bg-amber-50 text-amber-700 border-amber-200"],
};

export const StatusBadge = ({ status }) => {
  const [label, cls] = STYLES[status || "pending"];
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap ${cls}`}>{label}</span>;
};

export const formatDate = (iso) =>
  new Date(iso).toLocaleString("fr-BE", { timeZone: "Europe/Brussels", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
